import React, { useEffect, useState } from "react";
import api, { API, getToken } from "../../lib/api";
import { PiggyBank, Download } from "lucide-react";

export default function PortalBudget() {
  const [docs, setDocs] = useState(null);
  useEffect(() => { api.get("/portal/budgets").then(({ data }) => setDocs(data)); }, []);
  if (!docs) return <div className="p-6 font-bold uppercase text-sm">Loading budget documents…</div>;

  const download = async (d) => {
    const token = getToken();
    const res = await fetch(`${API}/portal/budgets/${d.id}/file`, { headers: { Authorization: `Bearer ${token}` }, credentials: "include" });
    const url = URL.createObjectURL(await res.blob());
    const a = document.createElement("a");
    a.href = url; a.download = d.filename || d.title; a.click();
    URL.revokeObjectURL(url);
  };

  if (docs.length === 0) {
    return (
      <div className="bg-white border border-stone-200 p-10 text-center space-y-2" data-testid="portal-budget-placeholder">
        <PiggyBank size={32} className="mx-auto text-[#7C9673]" />
        <div className="font-bold uppercase tracking-wide">No Budget Documents Yet</div>
        <p className="text-sm text-stone-500 max-w-md mx-auto">Your vineyard manager will upload the annual budget and monthly budget-vs-actual reports here. Check back soon.</p>
      </div>
    );
  }

  return (
    <div className="space-y-2" data-testid="portal-budget">
      {docs.map((d) => (
        <div key={d.id} data-testid={`portal-budget-${d.id}`} className="bg-white border border-stone-200 p-4 flex flex-wrap items-center gap-3">
          <PiggyBank size={18} className="text-[#7C9673] shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="font-bold">{d.title} <span className="text-[10px] font-bold uppercase px-2 py-0.5 bg-stone-100 border border-stone-200 ml-1">{d.doc_type}</span></div>
            <div className="text-xs text-stone-500">Ranch {d.ranch_number}{d.period ? ` · ${d.period}` : ""} · {d.created_at?.slice(0, 10)}</div>
          </div>
          <button data-testid={`portal-budget-download-${d.id}`} onClick={() => download(d)}
            className="h-10 px-4 bg-[#1F3D34] text-white font-bold uppercase text-xs flex items-center gap-2">
            <Download size={14} /> Download
          </button>
        </div>
      ))}
    </div>
  );
}
